module.exports = __webpack_public_path__ + "img/x-icon.886ba32a.svg";